import React from "react"
import DesktopContainer from "~/components/DesktopContainer"
import Spacer from "~/components/Spacer"
import Spinner from "~/components/loader/Spinner"
import StatusInformation from "~/components/loader/StatusInformation"
import useInject from "~/hooks/useInject"
import { FETCHER_TIMEOUT_DURATIONS } from "~/utilities/constants"

const mapStore = (store) => ({
  fetcherName: store.divorceLookup.fetcherName,
})

const DivorceLoader = () => {
  const { fetcherName } = useInject(mapStore)

  return (
    <DesktopContainer>
      <Spacer mobile={66} desktop={130} />

      <div>
        <Spinner isMobile />
      </div>
      <StatusInformation
        itemName="cases"
        duration={FETCHER_TIMEOUT_DURATIONS.divorce[fetcherName]}
      />

      <Spacer mobile={250} desktop={500} />
    </DesktopContainer>
  )
}

export default DivorceLoader
